export default function Marquee({ items, className = "", slow = false, separator = "★" }) {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((t, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="mx-6 font-mono text-sm sm:text-base font-bold uppercase tracking-[0.2em]">{t}</span>
          <span aria-hidden>{separator}</span>
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y-2 border-black py-3 ${className}`}>
      <div className={`flex w-max ${slow ? "animate-marquee-slow" : "animate-marquee"}`}>
        <Row />
        <Row />
      </div>
    </div>
  );
}
